<template>
    <div class="sf-root">
        <!-- Famiglia icone: una griglia 24, stroke 1.8, terminali tondi.
             Definite una volta e richiamate con <use>: non possono divergere. -->
        <svg width="0" height="0" class="ef-icon-defs" aria-hidden="true" focusable="false">
            <symbol id="sf-pesi" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
                <rect x="2.6" y="10" width="2.6" height="4" rx="1.1" />
                <rect x="5.8" y="7.6" width="3.2" height="8.8" rx="1.4" />
                <rect x="15" y="7.6" width="3.2" height="8.8" rx="1.4" />
                <rect x="18.8" y="10" width="2.6" height="4" rx="1.1" />
                <path d="M9 12h6" />
            </symbol>
            <symbol id="sf-corsi" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
                <circle cx="12" cy="7" r="2.4" />
                <path d="M8.4 18.6v-1.8a3.6 3.6 0 0 1 7.2 0v1.8" />
                <circle cx="4.7" cy="9.2" r="1.7" />
                <path d="M1.9 18.6v-1.3a2.8 2.8 0 0 1 2.8-2.8" />
                <circle cx="19.3" cy="9.2" r="1.7" />
                <path d="M22.1 18.6v-1.3a2.8 2.8 0 0 0-2.8-2.8" />
            </symbol>
            <symbol id="sf-personal" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
                <circle cx="8.4" cy="7.4" r="2.6" />
                <path d="M4 19v-2.2a4.4 4.4 0 0 1 8.8 0V19" />
                <circle cx="17.4" cy="9.4" r="2" />
                <path d="M14 19v-1.7a3.4 3.4 0 0 1 6.8 0V19" />
            </symbol>
            <symbol id="sf-bia" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
                <rect x="3.2" y="4.2" width="17.6" height="15.6" rx="2.8" />
                <path d="M8 16.2v-3.4M12 16.2v-6.6M16 16.2v-4.8" />
            </symbol>
            <symbol id="sf-tessera" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
                <rect x="2.6" y="5.2" width="18.8" height="13.6" rx="2.6" />
                <path d="M2.6 9.6h18.8" />
                <path d="M6.4 14.4h4.2" />
            </symbol>
            <symbol id="sf-ingresso" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
                <path d="M3.4 8.4V6.8a1.6 1.6 0 0 1 1.6-1.6h14a1.6 1.6 0 0 1 1.6 1.6v1.6a2.4 2.4 0 0 0 0 7.2v1.6a1.6 1.6 0 0 1-1.6 1.6H5a1.6 1.6 0 0 1-1.6-1.6v-1.6a2.4 2.4 0 0 0 0-7.2Z" />
                <path d="M13.4 8.6v1.8M13.4 13.6v1.8" />
            </symbol>
            <symbol id="sf-chevron" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round">
                <path d="M9.5 5.5l6.5 6.5-6.5 6.5" />
            </symbol>
            <symbol id="sf-arrow" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round">
                <path d="M4.5 12h14M12.5 6l6 6-6 6" />
            </symbol>
        </svg>

        <!-- La home è il fallback di ogni stato non riconosciuto: se currentView
             finisse su un valore senza vista (bfcache, stato ripristinato dal
             browser) resterebbe altrimenti solo il fondo blu, senza via d'uscita. -->
        <div v-if="!isDetailView" class="sf-view">
            <div class="sf-topbar">
                <button v-if="isKiosk" type="button" class="sf-back" @click="$router.push('/kiosk')"
                    aria-label="Torna indietro">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4"
                        stroke-linecap="round" stroke-linejoin="round"><path d="M19 12H5M11 6l-6 6 6 6" /></svg>
                </button>
                <span v-else class="sf-back-spacer"></span>
                <img src="/elite-logo-white.png" alt="Elite Fitness" class="sf-logo" />
            </div>
            <h1 class="sf-view-title">Cosa vuoi acquistare?</h1>

            <div class="sf-menu">
                <button v-for="option in options" :key="option.name" type="button" class="sf-card sf-card--menu"
                    @click="navigateTo(option.view)">
                    <span class="sf-card-head">
                        <span class="sf-tile"><svg><use :href="'#sf-' + option.icon" /></svg></span>
                        <span class="sf-card-name">{{ option.name }}</span>
                    </span>
                    <span class="sf-card-sub">{{ option.sub }}</span>
                    <span class="sf-go"><svg><use :href="option.opens ? '#sf-chevron' : '#sf-arrow'" /></svg></span>
                </button>
            </div>
        </div>

        <div v-if="currentView === 'sala_pesi'" class="sf-view">
            <div class="sf-topbar">
                <button type="button" class="sf-back" @click="navigateTo('home')" aria-label="Torna indietro">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4"
                        stroke-linecap="round" stroke-linejoin="round"><path d="M19 12H5M11 6l-6 6 6 6" /></svg>
                </button>
                <img src="/elite-logo-white.png" alt="Elite Fitness" class="sf-logo" />
            </div>
            <h1 class="sf-view-title">Sala pesi</h1>

            <div class="sf-actions">
                <a class="sf-card sf-card--action" href="/checkout">
                    <span class="sf-tile"><svg><use href="#sf-tessera" /></svg></span>
                    <span class="sf-card-name">Abbonati</span>
                    <span class="sf-go"><svg><use href="#sf-arrow" /></svg></span>
                </a>
                <a class="sf-card sf-card--action" href="/checkout?productId=6821d62704042740a302c9c0">
                    <span class="sf-tile"><svg><use href="#sf-ingresso" /></svg></span>
                    <span class="sf-card-name">Ingressi singoli</span>
                    <span class="sf-go"><svg><use href="#sf-arrow" /></svg></span>
                </a>
            </div>

            <!-- Pannello di lettura: superficie chiara, testo scuro. I contenuti sono
                 invariati; cambia solo che le due sedi stanno affiancate invece che
                 una sotto l'altra, e che a scorrere è il riquadro, non la pagina. -->
            <div class="sf-panel sf-panel--split">
                <div>
                <h3>Sede di Rende <span v-if="is24h(centerForCity('Rende'))" class="sf-badge">H24</span></h3>
                <dl v-if="openingRows(centerForCity('Rende'))" class="sf-hours">
                    <div v-for="row in openingRows(centerForCity('Rende'))" :key="'rende-' + row.label"><dt>{{ row.label }}</dt><dd>{{ row.value }}</dd></div>
                </dl>
                <p>
                    Una palestra ampia e completa, con attrezzature a carico libero e dischi,
                    perfetta per chi ama la varietà e vuole allenarsi senza limiti.
                </p>
                <p>
                    Grazie alla grande disponibilità di macchinari e postazioni,
                    è ideale sia per chi punta a massimizzare i carichi e le performance,
                    sia per chi desidera un allenamento vario e personalizzabile.
                </p>
                <p>
                    Una struttura adatta a tutte le fasce d’età e livelli di esperienza,
                    dall’appassionato alle prime armi all’atleta più esperto.
                </p>

                </div>

                <div>
                <h3>Sede di Montalto <span v-if="is24h(centerForCity('Montalto'))" class="sf-badge">H24</span></h3>
                <dl v-if="openingRows(centerForCity('Montalto'))" class="sf-hours">
                    <div v-for="row in openingRows(centerForCity('Montalto'))" :key="'montalto-' + row.label"><dt>{{ row.label }}</dt><dd>{{ row.value }}</dd></div>
                </dl>
                <p>
                    Un ambiente luminoso, comodo e immediato, dove allenarsi è semplice e piacevole.
                </p>
                <p>
                    Le attrezzature con pacco pesi Technogym garantiscono ergonomia,
                    facilità d’uso e massima funzionalità, senza la necessità di caricare e scaricare dischi.
                </p>
                <p>
                    Qui il comfort è al primo posto:
                    zero complicazioni, spazi curati e un’atmosfera tranquilla per allenarsi in totale serenità,
                    che tu abbia poco tempo o voglia dedicarti a un workout senza pensieri.
                </p>
                </div>

                <p class="sf-panel-note"><em>L’abbonamento, tranne rare promo, è attivo su entrambe le sedi.</em></p>
            </div>
        </div>

        <div v-if="currentView === 'corsi'" class="corsi">
            <div class="container-fluid" style="padding-top: 20px; padding-bottom: 20px;">
                <button class="back-button" @click="navigateTo('home')">← Torna Indietro</button>
                <div v-for="group in groupedCourses" :key="group.centerId" class="course-group">
                    <div class="group-header" @click="toggleGroup(group.centerId)">
                        <span class="group-title">{{ group.centerName }}</span>
                        <i v-if="isOpen(group.centerId)" class="fa-solid fa-chevron-up"></i>
                        <i v-else class="fa-solid fa-chevron-down"></i>
                    </div>
                    <div v-show="isOpen(group.centerId)" class="courses-list">
                        <div class="grid">
                            <div v-for="course in group.courses" :key="course.id" class="course-item"
                                @click="goToCheckout(course)">
                                <span class="course-title">{{ course.name }}</span>
                                <ul class="course-details">
                                    <li v-for="time in course.timeSlots" v-bind:key="time.dayOfWeek">{{
                                        tl(time.dayOfWeek) }}:
                                        {{
                                            convertToHHMM(time.startTime) }} - {{ convertToHHMM(time.endTime) }}</li>
                                </ul>
                                <div class="course-price" v-if="priceByServiceId[course.serviceId] !== null">
                                    <template v-if="priceByServiceId[course.serviceId] === undefined">
                                        <span class="course-price-dim">…</span>
                                    </template>
                                    <template v-else-if="priceByServiceId[course.serviceId]">
                                        <span class="course-price-label">Mensile</span>
                                        <template v-if="priceByServiceId[course.serviceId].discountedPrice !== null">
                                            <span class="course-price-was">{{ formattaPrezzo(priceByServiceId[course.serviceId].price) }} €</span>
                                            <span class="course-price-now">{{ formattaPrezzo(priceByServiceId[course.serviceId].discountedPrice) }} €</span>
                                        </template>
                                        <span v-else class="course-price-now">{{ formattaPrezzo(priceByServiceId[course.serviceId].price) }} €</span>
                                    </template>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>

        <div v-if="currentView === 'corsi_sala_pesi'" class="corsi">
            <div class="container-fluid" style="padding-top: 20px; padding-bottom: 20px;">
                <button class="back-button" @click="navigateTo('home')">← Torna Indietro</button>
                <div v-for="group in groupedCourses" :key="group.centerId" class="course-group">
                    <div class="group-header" @click="toggleGroup(group.centerId)">
                        <span class="group-title">{{ group.centerName }}</span>
                        <i v-if="isOpen(group.centerId)" class="fa-solid fa-chevron-up"></i>
                        <i v-else class="fa-solid fa-chevron-down"></i>
                    </div>
                    <div v-show="isOpen(group.centerId)" class="courses-list">
                        <div class="grid">
                            <div v-for="course in group.courses" :key="course.id" class="course-item"
                                @click="goToCheckout(course, false)">
                                <span class="course-title">{{ course.name }}</span>
                                <ul class="course-details">
                                    <li v-for="time in course.timeSlots" v-bind:key="time.dayOfWeek">{{
                                        tl(time.dayOfWeek) }}:
                                        {{
                                            convertToHHMM(time.startTime) }} - {{ convertToHHMM(time.endTime) }}</li>
                                </ul>
                                <div class="course-price" v-if="priceByServiceId[course.serviceId] !== null">
                                    <template v-if="priceByServiceId[course.serviceId] === undefined">
                                        <span class="course-price-dim">…</span>
                                    </template>
                                    <template v-else-if="priceByServiceId[course.serviceId]">
                                        <span class="course-price-label">Mensile</span>
                                        <template v-if="priceByServiceId[course.serviceId].discountedPrice !== null">
                                            <span class="course-price-was">{{ formattaPrezzo(priceByServiceId[course.serviceId].price) }} €</span>
                                            <span class="course-price-now">{{ formattaPrezzo(priceByServiceId[course.serviceId].discountedPrice) }} €</span>
                                        </template>
                                        <span v-else class="course-price-now">{{ formattaPrezzo(priceByServiceId[course.serviceId].price) }} €</span>
                                    </template>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div v-if="currentView === 'personal_training'" class="sf-view">
            <div class="sf-topbar">
                <button type="button" class="sf-back" @click="navigateTo('home')" aria-label="Torna indietro">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4"
                        stroke-linecap="round" stroke-linejoin="round"><path d="M19 12H5M11 6l-6 6 6 6" /></svg>
                </button>
                <img src="/elite-logo-white.png" alt="Elite Fitness" class="sf-logo" />
            </div>
            <h1 class="sf-view-title">Personal Training</h1>

            <div class="sf-actions sf-actions--single">
                <a class="sf-card sf-card--action" href="/checkout?productId=676fea0ddc015ecc671bfd32">
                    <span class="sf-tile"><svg><use href="#sf-personal" /></svg></span>
                    <span class="sf-card-name">Iscriviti</span>
                    <span class="sf-go"><svg><use href="#sf-arrow" /></svg></span>
                </a>
            </div>

            <div class="sf-panel">
                <h3>L’esperienza esclusiva</h3>

                <p><strong>Sei pronto a fare davvero la differenza?</strong></p>
                <p>
                    Il Personal Training non è un semplice allenamento:
                    è un percorso strutturato, programmato e seguito passo dopo passo,
                    studiato per portarti al massimo del tuo potenziale.
                </p>

                <p>
                    A differenza del Target Training, che offre una consulenza iniziale,
                    una scheda personalizzata e assistenza in sala in base all’affluenza,
                    il Personal Training va molto oltre:
                </p>

                <p>
                    Immagina di avere al tuo fianco un professionista che non solo ti prepara una scheda,
                    ma sviluppa per te una programmazione annuale, così che ogni scheda sia collegata alla successiva
                    e ogni settimana porti un progresso reale.
                </p>

                <p>
                    Grazie ai test iniziali e intermedi, il Personal Trainer sa esattamente quali esercizi
                    sono più efficaci per te, rendendo il tuo percorso unico, sicuro e mirato.
                </p>

                <h3 style="margin-top:20px;">Il Personal Training è:</h3>
                <div style="margin-left: 10px;">
                    <p>🔑 <strong>Esclusivo</strong> – Un rapporto 1-to-1, in cui tutta l’attenzione è dedicata a te.
                    </p>
                    <p>🚀 <strong>Strutturato</strong> – Una programmazione a lungo termine con progressioni studiate e
                        controllate.</p>
                    <p>🛡️ <strong>Sicuro</strong> – Ogni esercizio è selezionato grazie ai test iniziali e
                        supervisionato in ogni momento.</p>
                    <p>📊 <strong>Misurabile</strong> – Test, feedback e monitoraggi costanti per avere sempre chiaro a
                        che punto sei.</p>
                    <p>🔥 <strong>Efficace</strong> – Ogni settimana avanzi: per essere ciò che non sei mai stato devi
                        fare quello che non hai mai fatto.</p>
                </div>

                <p style="margin-top:15px;">
                    Con il Personal Training non ti limiti a seguire un programma:
                    costruisci un percorso evolutivo che ti porta a risultati veloci,
                    senza compromessi e senza perdite di tempo.
                </p>

                <p><em>Un investimento su di te, sulla tua salute e sulla tua trasformazione.</em></p>
            </div>
        </div>
    </div>
</template>

<script>
import { IS_KIOSK } from '@/config/kiosk';

export default {
    data() {
        return {
            isKiosk: IS_KIOSK,
            currentView: 'home',
            // `icon` è la chiave di un <symbol> definito una volta nel template:
            // niente immagini remote (le vecchie URL WordPress erano morte da tempo,
            // e comparivano solo su hover, quindi mai su touch).
            // `opens` distingue chi apre un'altra vista da chi va dritto al checkout:
            // cambia solo il glifo, non il peso visivo.
            options: [
                { name: 'Sala pesi', view: 'sala_pesi', icon: 'pesi', sub: 'Abbonamenti e ingressi', opens: true },
                { name: 'Corsi', view: 'corsi', icon: 'corsi', sub: 'Orari e sedi', opens: true },
                //{ name: 'Sala pesi + Corsi', view: 'corsi_sala_pesi', icon: 'corsi', sub: 'Sala pesi e corsi insieme', opens: true },
                { name: 'Personal Training', view: 'personal_training', icon: 'personal', sub: 'Allenamenti 1-a-1', opens: true },
                { name: 'BIA', view: 'bia', icon: 'bia', sub: 'Massa magra, grasso, acqua', opens: false },
                //{ name: 'Nutrizione', view: 'nutrizione', icon: 'nutrizione', sub: 'Percorso con il nutrizionista', opens: false },
            ],
            courses: [],
            centers: [],
            expandedGroups: {},
            // serviceId -> { price, discountedPrice|null } · null = nessun prezzo mensile,
            // undefined (chiave assente) = non ancora caricato.
            priceByServiceId: {},
            promoCodes: [],
        };
    },
    methods: {
        navigateTo(view) {
            // I rami che portano dritti al checkout NON sono viste di questo
            // componente: assegnare currentView prima di uscire lascerebbe la
            // schermata vuota (nessun v-if corrisponde) se la navigazione tarda
            // o se si torna indietro col browser e lo stato viene ripristinato.
            const direct = {
                bia: 'checkout?productId=0e296747-8d6d-4197-9cff-0cd1f683df29',
                ingressi: 'checkout?productId=6821d62704042740a302c9c0',
                nutrizione: 'checkout?productId=f42eb4c3-c637-4280-bed9-f5918721662d',
            };
            if (direct[view]) {
                window.location.href = direct[view];
                return;
            }

            this.currentView = view;
            if (view === 'corsi' || view === 'corsi_sala_pesi') {
                this.fetchCourses();
                this.fetchCenters();
            }
        },
        async fetchCourses() {
            try {
                const response = await fetch('https://api.elitefitness.it/api/open/services');
                this.courses = await response.json();
                // Mantieni solo i corsi di tipo COURSE e filtra quelli con enable === false
                this.courses = this.courses.filter(course => course.type === 'COURSE');
                this.fetchCoursePrices();
            } catch (error) {
                console.error('Errore nel recupero dei corsi:', error);
            }
        },

        /**
         * Forma comparabile di un nome di variazione.
         *
         * Stessa regola di `util/VariationNames` lato server, e per lo stesso motivo: nei dati
         * reali convivono nomi con spazi ai margini e maiuscole diverse. Un confronto letterale
         * fallirebbe su una parte dei corsi e non su tutti, che è il modo peggiore di sbagliare
         * perché sembra funzionare.
         */
        normalizzaNomeVariazione(nome) {
            return (nome ?? '').trim().toLowerCase();
        },

        /** Il prezzo della variazione mensile fra quelle attive, se esiste. */
        prezzoMensile(product) {
            const attive = (product?.variations ?? []).filter(v => v.active !== false);
            const mensile = attive.find(v => this.normalizzaNomeVariazione(v.variationName) === 'mensile');
            const prezzo = mensile?.price;
            return typeof prezzo === 'number' && !Number.isNaN(prezzo) ? prezzo : null;
        },

        /**
         * Le promo pubbliche che si applicano davvero a questo prodotto in questa sede.
         *
         * I due filtri non sono prudenza: `GET /api/promo/{code}/variations` sconta **qualunque**
         * prodotto gli venga passato, anche uno che la promo non copre, e restituisce un numero
         * plausibile senza segnalare nulla. Interrogarlo prima di filtrare significherebbe
         * mostrare sconti inesistenti. Si filtra quindi a monte, come in `informazioniShowcaseData`:
         *
         * - `existingMembersOnly`: le promo riservate a chi è già tesserato non vanno mostrate a
         *   un visitatore, perché al checkout `validate()` le rifiuterebbe;
         * - `filters.productIds`: la promo deve nominare questo prodotto;
         * - `filters.centerIds`: assente o vuoto vale per tutte le sedi, altrimenti deve contenere
         *   la sede. Qui la sede è nota perché le card sono già raggruppate per centro.
         */
        promoApplicabili(productId, centerId) {
            return (this.promoCodes ?? []).filter(p => {
                if (p?.existingMembersOnly === true) return false;
                const prodotti = p?.filters?.productIds ?? [];
                if (!prodotti.includes(productId)) return false;
                const sedi = (p?.filters?.centerIds ?? []).filter(Boolean);
                return sedi.length === 0 || sedi.includes(centerId);
            });
        },

        /**
         * Prezzo mensile di ogni corso, con lo sconto della promo migliore se ne esiste una.
         *
         * Si mostra **solo** la variazione mensile: niente ripiego sul minimo fra le variazioni e
         * niente «a partire da» (deciso in elitefitness-react-app b4965a3, refs #207 e #231). Il
         * minimo può venire da una durata che al socio non interessa, ed è un numero diverso
         * presentato come se rispondesse alla stessa domanda. Senza variazione mensile il corso
         * resta senza prezzo, e l'assenza è voluta: si vede, e porta a sistemare il listino.
         */
        async fetchCoursePrices() {
            try {
                const risposta = await fetch('https://api.elitefitness.it/api/open/promoCodes/available');
                this.promoCodes = await risposta.json();
            } catch (error) {
                // Senza promo i prezzi di listino restano corretti: si prosegue.
                console.error('Errore nel recupero delle promozioni:', error);
                this.promoCodes = [];
            }

            await Promise.all(this.courses.map(async (course) => {
                const serviceId = course?.serviceId;
                if (!serviceId) return;
                try {
                    const risposta = await fetch(
                        `https://api.elitefitness.it/api/products/service/${encodeURIComponent(serviceId)}`);
                    const prodotti = await risposta.json();
                    // Stesso criterio del checkout: il primo prodotto collegato al servizio.
                    const product = Array.isArray(prodotti) ? prodotti[0] : null;
                    const listino = this.prezzoMensile(product);
                    if (listino === null) {
                        this.priceByServiceId = { ...this.priceByServiceId, [serviceId]: null };
                        return;
                    }
                    const scontato = await this.prezzoMensileScontato(course, product, listino);
                    this.priceByServiceId = {
                        ...this.priceByServiceId,
                        [serviceId]: { price: listino, discountedPrice: scontato },
                    };
                } catch (error) {
                    console.error(`Errore nel recupero del prezzo per ${serviceId}:`, error);
                    this.priceByServiceId = { ...this.priceByServiceId, [serviceId]: null };
                }
            }));
        },

        /** Il mensile scontato dalla promo più conveniente applicabile, o null se non ce ne sono. */
        async prezzoMensileScontato(course, product, listino) {
            const productId = product?.id ?? course?.productId;
            const centerId = (course?.centersId && course.centersId.length) ? course.centersId[0] : null;
            const promos = this.promoApplicabili(productId, centerId);
            if (promos.length === 0) return null;

            const scontati = [];
            for (const promo of promos) {
                try {
                    const risposta = await fetch(
                        `https://api.elitefitness.it/api/promo/${encodeURIComponent(promo.code)}/variations`
                        + `?productId=${encodeURIComponent(productId)}`);
                    const variazioni = await risposta.json();
                    const mensile = (Array.isArray(variazioni) ? variazioni : [])
                        .find(v => this.normalizzaNomeVariazione(v.variationName) === 'mensile');
                    const prezzo = Number(mensile?.discountedPrice);
                    if (!Number.isNaN(prezzo) && prezzo >= 0 && prezzo < listino) scontati.push(prezzo);
                } catch (error) {
                    console.error(`Promo ${promo.code} non applicabile a ${productId}:`, error);
                }
            }
            return scontati.length > 0 ? Math.min(...scontati) : null;
        },

        /**
         * Prezzo in euro: intero quando lo è (50, non 50,00), altrimenti due decimali
         * come si scrivono i prezzi (35,70 e non 35,7).
         */
        formattaPrezzo(valore) {
            const intero = Number.isInteger(Number(valore));
            return new Intl.NumberFormat('it-IT', {
                minimumFractionDigits: intero ? 0 : 2,
                maximumFractionDigits: intero ? 0 : 2,
            }).format(valore);
        },
        async fetchCenters() {
            try {
                const response = await fetch('https://api.elitefitness.it/api/open/centers');
                this.centers = await response.json();
            } catch (error) {
                console.error('Errore nel recupero dei corsi:', error);
            }
        },
        goToCheckout(course, bypass = true) {
            window.location.href = `/checkout?productId=${course.productId}&bypm=${bypass}`;
        },
        tl(day) {
            const days = {
                "MONDAY": "Lunedì",
                "TUESDAY": "Martedì",
                "WEDNESDAY": "Mercoledì",
                "THURSDAY": "Giovedì",
                "FRIDAY": "Venerdì",
                "SATURDAY": "Sabato",
                "SUNDAY": "Domenica"
            }
            return days[day];
        },
        convertToHHMM(timeString) {
            return timeString.split(':').slice(0, 2).join(':');
        },
        toggleGroup(center) {
            this.expandedGroups[center] = !this.expandedGroups[center];
        },
        isOpen(center) {
            return !!this.expandedGroups[center]
        },
        // Associa una sede "logica" (per città/nome) al centro reale caricato da /api/open/centers.
        centerForCity(city) {
            const q = (city || '').toLowerCase();
            return this.centers.find(c =>
                (c.city || '').toLowerCase() === q || (c.name || '').toLowerCase().includes(q)
            ) || null;
        },
        is24h(center) {
            return !!(center && center.openingHours && center.openingHours.open24h);
        },
        // Righe {label, value} degli orari di apertura, raggruppando i giorni
        // consecutivi con lo stesso orario (es. "Lunedì – Venerdì"). Null se H24
        // (gestito dal badge) o se il centro non ha orari configurati.
        openingRows(center) {
            const oh = center && center.openingHours;
            if (!oh || oh.open24h) return null;
            const order = ['MONDAY', 'TUESDAY', 'WEDNESDAY', 'THURSDAY', 'FRIDAY', 'SATURDAY', 'SUNDAY'];
            const slots = oh.weeklySchedule || [];
            const valueFor = (day) => {
                const daySlots = slots
                    .filter(x => x.dayOfWeek === day)
                    .sort((a, b) => (a.startTime || '').localeCompare(b.startTime || ''));
                if (!daySlots.length) return 'Chiuso';
                return daySlots.map(s => `${this.convertToHHMM(s.startTime)} – ${this.convertToHHMM(s.endTime)}`).join(', ');
            };
            const rows = [];
            let i = 0;
            while (i < order.length) {
                const val = valueFor(order[i]);
                let j = i;
                while (j + 1 < order.length && valueFor(order[j + 1]) === val) j++;
                const label = i === j ? this.tl(order[i]) : `${this.tl(order[i])} – ${this.tl(order[j])}`;
                rows.push({ label, value: val });
                i = j + 1;
            }
            return rows;
        }
    },
    computed: {
        /** Viste di dettaglio effettivamente renderizzate dal template. */
        isDetailView() {
            return ['sala_pesi', 'corsi', 'corsi_sala_pesi', 'personal_training']
                .includes(this.currentView);
        },
        groupedCourses() {
            const map = {}
            // raggruppa per primo centerId
            this.courses.forEach(c => {
                console.log(c);
                const firstCenterId = (c.centersId && c.centersId.length) ? c.centersId[0] : 'Sconosciuto'
                if (!map[firstCenterId]) map[firstCenterId] = []
                map[firstCenterId].push(c)
            })
            // trasforma in array ordinato e aggiunge centerName
            return Object.keys(map)
                .sort()
                .map(centerId => {
                    const ctr = this.centers.find(x => x.id === centerId)
                    return {
                        centerId,
                        centerName: ctr.name,
                        courses: map[centerId]
                    }
                })
        }
    },
    mounted() {
        // Carica i centri (con openingHours) all'avvio: gli orari servono già
        // nella vista "sala pesi", non solo in "corsi".
        this.fetchCenters();
    },
};
</script>

<style scoped>
/* ============================================================
   Scelta servizio — superfici chiare su ambiente blu.
   Regola unica del flusso: card = si tocca, panel = si legge.
   Prima card e blocchi informativi avevano lo stesso bordo rosso
   ed erano indistinguibili.
   ============================================================ */
.sf-root {
    --blue: #2e348c;
    --blue-900: #262b7a;
    --ink: #16195e;
    --ink-soft: #4a4f85;
    --surface: #fff;
    --pressed: #f7f8ff;
    --tile: #eceef8;
    --panel-bg: #f7f8fc;
    --hairline: #e2e5f4;

    font-family: 'Montserrat', sans-serif;
    background-color: var(--blue);
    color: #fff;
    min-height: 100dvh;
    width: 100%;
    padding: 0;
    margin: 0;
    display: block;
    text-align: left;
}

.ef-icon-defs { position: absolute; }

/* Colonna centrata: su schermi larghi il blu resta ambiente, non si allarga
   il contenuto fino ai bordi. */
/* Altezza vincolata al viewport: a scorrere deve essere il pannello di lettura,
   non la pagina. Così il tasto indietro e le azioni restano sempre a schermo.
   Su telefono la regola viene rilasciata (vedi media query). */
.sf-view {
    max-width: 940px;
    margin: 0 auto;
    padding: 20px 22px 22px;
    display: flex;
    flex-direction: column;
    height: 100dvh;
    overflow: hidden;
}

.sf-topbar {
    display: flex;
    align-items: baseline;
    justify-content: space-between;
    padding-bottom: 14px;
    border-bottom: 1px solid rgba(255, 255, 255, .16);
}
/* Lo spacer tiene il posto del tasto indietro dove non c'è, così il logo
   resta ancorato a destra e non si muove tra una vista e l'altra. */
.sf-back-spacer { width: 44px; height: 44px; display: block; }
/* Il file del logo è quadrato (1000x1000) con il marchio al centro:
   sotto i ~48px il lettering diventa illeggibile. */
.sf-logo { height: 64px; width: auto; display: block; }
.sf-back {
    width: 44px; height: 44px;
    display: grid; place-items: center;
    background: rgba(255, 255, 255, .14);
    border: none; border-radius: 12px;
    color: #fff; cursor: pointer;
    -webkit-tap-highlight-color: transparent;
}
.sf-back svg { width: 22px; height: 22px; }
.sf-back:active { background: rgba(255, 255, 255, .3); }

.sf-view-title {
    font-family: 'Montserrat', sans-serif;
    font-size: clamp(1.4rem, 2.4vw, 1.85rem);
    font-weight: 700;
    margin: 18px 0 16px;
}

/* ---- griglia delle voci ---- */
.sf-menu {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 16px;
}

.sf-card {
    position: relative;
    background: var(--surface);
    border: none;
    border-radius: 20px;
    box-shadow: 0 6px 0 rgba(0, 0, 0, .20);
    text-align: left;
    text-decoration: none;
    cursor: pointer;
    font-family: inherit;
    transition: transform 90ms ease, box-shadow 90ms ease, background-color 90ms ease;
    -webkit-tap-highlight-color: transparent;
    touch-action: manipulation;
    user-select: none;
}
/* Sul touch non esiste hover: la conferma è il tasto che scende. */
.sf-card:active {
    transform: translateY(4px);
    box-shadow: 0 2px 0 rgba(0, 0, 0, .20);
    background: var(--pressed);
}
.sf-card:focus-visible { outline: 3px solid #fff; outline-offset: 3px; }

.sf-card--menu {
    display: block;
    padding: 16px 18px 54px;
    min-height: 128px;
}

.sf-card-head { display: flex; align-items: center; gap: 12px; }
.sf-tile {
    width: 42px; height: 42px; flex: 0 0 42px;
    border-radius: 11px;
    background: var(--tile);
    color: var(--blue);
    display: grid;
    place-items: center;
}
.sf-tile svg { width: 23px; height: 23px; }

.sf-card-name {
    font-size: clamp(1.05rem, 1.6vw, 1.3rem);
    font-weight: 700;
    color: var(--ink);
    line-height: 1.15;
}
.sf-card-sub {
    display: block;
    margin-top: 10px;
    font-size: clamp(.85rem, 1.1vw, .98rem);
    font-weight: 600;
    color: var(--ink-soft);
}

/* Affordance sussurrata: stesso peso per tutte le voci, cambia solo la forma
   (chevron = apre una vista, freccia = prosegue). */
.sf-go {
    position: absolute;
    right: 18px;
    bottom: 16px;
    width: 36px; height: 36px;
    border-radius: 10px;
    background: var(--tile);
    color: var(--blue);
    display: grid;
    place-items: center;
}
.sf-go svg { width: 20px; height: 20px; }

/* ---- azioni delle viste di dettaglio ---- */
.sf-actions {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 16px;
}
.sf-actions--single { grid-template-columns: minmax(0, 1fr); max-width: 540px; }

.sf-card--action {
    display: flex;
    align-items: center;
    gap: 14px;
    padding: 14px 18px;
    min-height: 72px;
}
.sf-card--action .sf-go { position: static; margin-left: auto; }

/* ---- pannello di lettura ---- */
.sf-panel {
    margin-top: 18px;
    background: var(--panel-bg);
    border-radius: 20px;
    padding: 18px 20px;
    color: var(--ink);
    flex: 1 1 auto;
    min-height: 0;
    overflow-y: auto;
    scrollbar-width: thin;
    scrollbar-color: #c3c8e4 transparent;
}
.sf-panel::-webkit-scrollbar { width: 10px; }
.sf-panel::-webkit-scrollbar-thumb {
    background: #c3c8e4;
    border-radius: 99px;
    border: 3px solid var(--panel-bg);
}
.sf-panel--split {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 26px;
    align-content: start;
}

.sf-panel h3 {
    font-family: 'Montserrat', sans-serif;
    font-size: 1.05rem;
    font-weight: 700;
    color: var(--ink);
    margin: 0 0 12px;
    display: flex;
    align-items: center;
    gap: 10px;
}
.sf-panel h3 + h3 { margin-top: 22px; }
.sf-panel p {
    font-size: .92rem;
    line-height: 1.45;
    color: var(--ink-soft);
    margin: 0 0 11px;
}
.sf-panel strong { color: var(--ink); }
.sf-panel-note {
    grid-column: 1 / -1;
    border-top: 1px solid var(--hairline);
    padding-top: 14px;
    margin-bottom: 0;
}

.sf-badge {
    font-size: .72rem;
    font-weight: 700;
    letter-spacing: .04em;
    background: var(--blue);
    color: #fff;
    border-radius: 999px;
    padding: 4px 12px;
}

.sf-hours {
    margin: 0 0 10px;
    display: grid;
    gap: 4px;
    font-size: .92rem;
}
.sf-hours > div { display: flex; justify-content: space-between; gap: 16px; }
.sf-hours dt { color: var(--ink-soft); }
.sf-hours dd {
    margin: 0;
    font-weight: 700;
    color: var(--ink);
    font-variant-numeric: tabular-nums;
}

/* ---- fascia inferiore ---- */

/* ---- elenco corsi: stesse superfici, niente bordi rossi ---- */
.corsi { max-width: 1100px; margin: 0 auto; padding: 28px 24px 32px; }
.course-group { margin-bottom: 22px; }
.group-header {
    background: rgba(255, 255, 255, .10);
    border: none;
    border-radius: 14px;
    padding: 16px 20px;
    margin-bottom: 14px;
    width: 100%;
    cursor: pointer;
    display: flex;
    justify-content: space-between;
    align-items: center;
    color: #fff;
}
.group-title { font-weight: 700; font-size: 1.2rem; }

.grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(260px, 1fr));
    gap: 16px;
    margin-top: 0;
}
.course-item {
    background: var(--surface);
    border: none;
    border-radius: 16px;
    padding: 18px 20px;
    cursor: pointer;
    /* Colonna con il prezzo spinto in fondo: i titoli dei corsi vanno da una a due
       righe, e senza questo il prezzo ballerebbe fra card affiancate della stessa riga. */
    display: flex;
    flex-direction: column;
    color: var(--ink);
    box-shadow: 0 5px 0 rgba(0, 0, 0, .18);
    transition: transform 90ms ease, box-shadow 90ms ease, background-color 90ms ease;
    -webkit-tap-highlight-color: transparent;
}
.course-item:active {
    transform: translateY(3px);
    box-shadow: 0 2px 0 rgba(0, 0, 0, .18);
    background: var(--pressed);
}
.course-title {
    font-weight: 700;
    font-size: 1.05rem;
    margin-bottom: 10px;
    display: block;
    color: var(--ink);
}
.course-details {
    list-style: none;
    padding: 0;
    margin: 0;
    font-size: .9rem;
    color: var(--ink-soft);
    font-variant-numeric: tabular-nums;
}

/* Il prezzo sta in fondo alla card, staccato dagli orari: sono due letture diverse.
   La card è cliccabile per intero, quindi non serve altro richiamo. */
.course-price {
    display: flex;
    align-items: baseline;
    flex-wrap: wrap;
    gap: 6px;
    margin-top: auto;
    padding-top: 14px;
    border-top: 1px solid rgba(0, 0, 0, .08);
    font-variant-numeric: tabular-nums;
}
.course-price-label {
    font-size: .8rem;
    color: var(--ink-soft);
    text-transform: uppercase;
    letter-spacing: .04em;
}
.course-price-now {
    font-weight: 700;
    font-size: 1.05rem;
    color: var(--ink);
}
/* Prezzo pieno quando una promo lo sconta: barrato e in secondo piano. */
.course-price-was {
    text-decoration: line-through;
    color: var(--ink-soft);
    font-size: .9rem;
}
/* Segnaposto durante il caricamento: occupa lo spazio, così la card non salta. */
.course-price-dim {
    color: var(--ink-soft);
}

.back-button {
    border: 0;
    background: transparent;
    color: #fff;
    font-size: 1rem;
    cursor: pointer;
    margin-bottom: 20px;
    padding-bottom: 8px;
    text-transform: uppercase;
    border-bottom: 2px solid rgba(255, 255, 255, .6);
    font-family: inherit;
}

/* ---- totem: schermo 1024x768, tocco, lettura a distanza ---- */
@media (min-width: 900px) {
    .sf-view { padding: 24px 28px 22px; }
    .sf-card--menu { min-height: 138px; }
}

/* ---- telefono: le card diventano righe ---- */
@media (max-width: 720px) {
    .sf-view { padding: 18px 16px 24px; }
    .sf-view-title { margin: 20px 0 16px; }
    .sf-menu { grid-template-columns: minmax(0, 1fr); gap: 12px; }
    .sf-card--menu {
        min-height: 0;
        padding: 16px;
        display: flex;
        align-items: center;
        gap: 14px;
        flex-wrap: wrap;
    }
    .sf-card--menu .sf-card-head { flex: 1 1 auto; }
    .sf-card-sub {
        order: 3;
        flex-basis: 100%;
        margin-top: 6px;
        margin-left: 66px;
    }
    .sf-card--menu .sf-go {
        position: static;
        width: 32px; height: 32px;
        background: transparent;
        color: var(--ink-soft);
    }
    .sf-tile { width: 48px; height: 48px; flex-basis: 48px; }
    .sf-tile svg { width: 26px; height: 26px; }

    .sf-actions { grid-template-columns: minmax(0, 1fr); gap: 12px; }
    .sf-panel--split { grid-template-columns: minmax(0, 1fr); gap: 20px; }
    /* Su telefono torna a scorrere la pagina: vincolare l'altezza qui
       schiaccerebbe il pannello in una finestrella. */
    .sf-panel { overflow: visible; }
    .sf-view { height: auto; overflow: visible; }

            }

@media (prefers-reduced-motion: reduce) {
    .sf-card, .course-item { transition: none; }
    .sf-card:active, .course-item:active { transform: none; }
}
</style>
